// config.js
//
// CRA inlines process.env.REACT_APP_* at build time, so these are baked into the
// bundle by `npm run build`. The compose stack passes them as build args; the
// fallbacks are the production URLs, so a plain `npm run build` still targets prod.

// Authentication is handled by Logto, configured separately in src/logto.js.

const config = {
  // Luxottica backend. In the compose stack this is '/api', served same-origin
  // by the frontend's nginx and proxied to the backend container.
  BACKEND_API_ADDRESS:
    process.env.REACT_APP_BACKEND_API_ADDRESS || 'https://luxottica.parallelia.com/api',

  // Other configuration options (add as needed)
  // apiTimeout: 30000,
  // environment: 'production',
};

export default config;
